require('./mortgageRequestCounterOffer.scss');

// @vendor
const React = require('react');
const PropTypes = require('prop-types');
const classNames = require('classnames');

// @components
const WizardSuccess = require('components/commons/wizardSuccess/wizardSuccess');

// @commons
const MortgageRequestCurrencyHelp = require('components/mortgageRequest/mortgageRequestCurrencyHelp/mortgageRequestCurrencyHelp');
const { FormattedText, formatText } = require('core/i18n').i18n;

// @constants
const { EURO_TEXT, FIRST_STEP } = require('constants/index');

// @helpers
const { mortgageCounterOfferText } = require('utilities/mortgageHelper');

const MortgageRequestCounterOfferCard = ({ title, amount, years, fee, feeRest, doAmountsDiffer, doTermsDiffer, secondCard, productType }) => {
    const classes = {
        card: 'mortgage-request-counter-offer__card',
        cardTitle: 'mortgage-request-counter-offer__card-title',
        cardFooter: 'mortgage-request-counter-offer__card-footer',
        cardLoan: classNames(
            'mortgage-request-counter-offer__card-loan',
            { 'mortgage-request-counter-offer__card-loan--second': secondCard }
        ),
        cardAmount: classNames(
            'mortgage-request-counter-offer__card-amount',
            { 'mortgage-request-counter-offer__card-amount--changed': doAmountsDiffer }
        ),
        cardSeparator: 'mortgage-request-counter-offer__card-separator',
        cardTime: classNames(
            'mortgage-request-counter-offer__card-term',
            { 'mortgage-request-counter-offer__card-term--changed': doTermsDiffer }
        ),
        cardFee: classNames(
            'mortgage-request-counter-offer__card-fee',
            { 'mortgage-request-counter-offer__card-fee--second': secondCard }
        ),
        cardQuotaText: 'mortgage-request-counter-offer__card-quota-text'
    }
    const formattedAmount = MortgageRequestCurrencyHelp({ currency: amount, symbol: EURO_TEXT, withDecimals: false })
    const yearText = `${years} ${formatText('mortgageRequestPreApprovalCounterOffer-mortgageRequestPreApprovalCounterOffer_years')}`;
    const newMonthlyFeeText = mortgageCounterOfferText(productType, fee, feeRest, classes);

    return (
        <div className={classes.card}>
            <p className={classes.cardTitle}>
                {title}
            </p>
            <footer className={classes.cardFooter}>
                <p className={classes.cardLoan}>
                    <span className={classes.cardAmount}>
                        {`${formattedAmount} `}
                    </span>
                    <span className={classes.cardSeparator}>
                        <FormattedText value="mortgageRequestPreApprovalCounterOffer-mortgageRequestPreApprovalCounterOffer_cardTo" />{' '}
                    </span>
                    <span className={classes.cardTime}>
                        {yearText}
                    </span>
                </p>
                {newMonthlyFeeText}
            </footer>
        </div>
    )
}

MortgageRequestCounterOfferCard.propTypes = {
    title: PropTypes.string.isRequired,
    amount: PropTypes.number.isRequired,
    years: PropTypes.number.isRequired,
    fee: PropTypes.number.isRequired,
    feeRest: PropTypes.number.isRequired,
    doAmountsDiffer: PropTypes.bool.isRequired,
    doTermsDiffer: PropTypes.bool.isRequired,
    secondCard: PropTypes.bool.isRequired,
    productType: PropTypes.string.isRequired,
}

class MortgageRequestCounterOffer extends React.Component {
    static productTypes = {
        FIJO: 'Fija',
        MIXTO: 'Mixta',
        VARIABLE: 'Variable'
    }

    static propTypes = {
        validateStep: PropTypes.func.isRequired,
        toggleCounterOfferView: PropTypes.func.isRequired,
        immMortgageRequest: PropTypes.object.isRequired,
        acceptPreApprovalCounterOffer: PropTypes.func.isRequired,
        preApprovalRequest: PropTypes.func.isRequired
    }

    constructor(props) {
        super(props);

        this.handleModifySimulationClick = this.handleModifySimulationClick.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleModifySimulationClick() {
        const { validateStep, toggleCounterOfferView, immMortgageRequest } = this.props;

        if (!immMortgageRequest.get('isFetching')) {
            validateStep(FIRST_STEP);
            toggleCounterOfferView(false);
        }
    }

    handleSubmit() {
        const {
            immMortgageRequest,
            acceptPreApprovalCounterOffer,
            preApprovalRequest
        } = this.props;
        const newAmount = immMortgageRequest.getIn(['co', 'newAmmount']);
        const newTerm = immMortgageRequest.getIn(['co', 'newTerm']);

        if (!immMortgageRequest.get('isFetching')) {
            acceptPreApprovalCounterOffer({ newAmount, newTerm });
            preApprovalRequest();
        }
    }

    render() {
        const { immMortgageRequest } = this.props;
        const classes = {
            container: 'mortgage-request-counter-offer',
            cards: 'mortgage-request-counter-offer__cards',
            description: 'mortgage-request-counter-offer__description',
        }
        const productType = MortgageRequestCounterOffer.productTypes[immMortgageRequest.get('productType')];
        const copies = {
            success: formatText('mortgageRequestPreApprovalCounterOffer-mortgageRequestPreApprovalCounterOffer_success', [productType]),
            firstCardTitle: formatText('mortgageRequestPreApprovalCounterOffer-mortgageRequestPreApprovalCounterOffer_firstCardTitle'),
            secondCardTitle: formatText('mortgageRequestPreApprovalCounterOffer-mortgageRequestPreApprovalCounterOffer_secondCardTitle'),
            mainButton: formatText('mortgageRequestPreApprovalCounterOffer-mortgageRequestPreApprovalCounterOffer_mainButton'),
            secondaryButton: formatText('mortgageRequestPreApprovalCounterOffer-mortgageRequestPreApprovalCounterOffer_secondaryButton')
        }
        const firstCardData = {
            amount: immMortgageRequest.getIn(['co', 'newAmmount']),
            term: immMortgageRequest.getIn(['co', 'newTerm']),
            fee: immMortgageRequest.getIn(['co', 'newFee']),
            feeRest: immMortgageRequest.getIn(['co', 'newFeeRest']) || 0,
        }
        const secondCardData = {
            amount: immMortgageRequest.getIn(['co', 'originalAmmount']),
            term: immMortgageRequest.getIn(['co', 'originalTerm']),
            fee: immMortgageRequest.getIn(['co', 'arrayprices', 0, 'fee']),
            feeRest: immMortgageRequest.getIn(['co', 'arrayprices', 0, 'feeRest']) || 0,
        }
        const doAmountsDiffer = firstCardData.amount !== secondCardData.amount;
        const doTermsDiffer = firstCardData.term !== secondCardData.term;

        return (
            <React.Fragment>
                <div className={classes.container}>
                    <WizardSuccess
                        successMessage={copies.success}
                        mainButton={{ label: copies.mainButton }}
                        onMainButtonClick={this.handleSubmit}
                        secondaryButton={{ label: copies.secondaryButton }}
                        onSecondaryButtonClick={this.handleModifySimulationClick}
                        secondaryButtonStyle={__CONTACT_CENTER__ ? 'secondary' : null}
                    >
                        <div className={classes.cards}>
                            <MortgageRequestCounterOfferCard
                                title={copies.firstCardTitle}
                                amount={firstCardData.amount}
                                years={firstCardData.term}
                                fee={firstCardData.fee}
                                feeRest={firstCardData.feeRest}
                                doAmountsDiffer={doAmountsDiffer}
                                doTermsDiffer={doTermsDiffer}
                                productType={productType}
                            />
                            <MortgageRequestCounterOfferCard
                                title={copies.secondCardTitle}
                                amount={secondCardData.amount}
                                years={secondCardData.term}
                                fee={secondCardData.fee}
                                feeRest={secondCardData.feeRest}
                                doAmountsDiffer={doAmountsDiffer}
                                doTermsDiffer={doTermsDiffer}
                                productType={productType}
                                secondCard
                            />
                        </div>
                        <p className={classes.description}>
                            <FormattedText value="mortgageRequestPreApprovalCounterOffer-mortgageRequestPreApprovalCounterOffer_description" />
                        </p>
                    </WizardSuccess>
                </div>
            </React.Fragment>
        )
    }
}

module.exports = MortgageRequestCounterOffer;
